import { useMutation } from '@tanstack/react-query';
import { InitAPI } from '@newo/api/gateway';
import axios from '@/utils/api/axiosInstance';

const initAPI = new InitAPI(axios);

export const useSuperAgentExportQuery = (
    onSuccess: (data: string | null) => void
) =>
    useMutation({
        onSuccess,
        mutationFn: async (data: FormData) => {
            return initAPI.exportSuperAgent(data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
        }
    });

export const useSuperAgentImportMutation = () =>
    useMutation({
        mutationFn: async (data: FormData) => {
            return initAPI.importSuperAgent(data, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });
        }
    });

export const useSuperAgentExportV1Query = (
    onSuccess: (result: string | null) => void,
    projectId?: string
) =>
    useMutation({
        onSuccess,
        mutationFn: async () => {
            if (!projectId) {
                throw new Error('Project ID is required');
            }
            return initAPI.exportSuperAgentV1({
                project_id: projectId
            });
        }
    });

export const useSuperAgentImportV1Mutation = () =>
    useMutation({
        mutationFn: async ({
            data,
            projectId
        }: {
            data: FormData;
            projectId?: string;
        }) => {
            return initAPI.importSuperAgentV1(data, projectId);
        }
    });
